import PropTypes from "prop-types";
import React from "react";
import FormField from "./FormField";
import {useField} from "formik";

const genderMap = require('../../../../../config/gender_map.json');

const genderOptions = Object.entries(genderMap).map(([value, label]) => ({label, value}));

const GenderField = ({entity, label, options = Object.keys(genderMap), required}) => {
  const genderFieldName = `${entity}.gender`;
  const genderDisplayFieldName = `${entity}.gender_display`;
  const [inputProps] = useField(genderFieldName);

  return (
    <div className="row">
      <FormField
        label={label}
        type="select"
        name={genderFieldName}
        options={genderOptions.filter(({value}) => options.includes(value))}
        colWidth={6}
        required={required}
      />

      {inputProps.value === "O" && (
        <FormField
          label="&nbsp;"
          type="text"
          name={genderDisplayFieldName}
          colWidth={6}
          placeholder="Self-Identify..."
        />
      )}
    </div>
  );
}

GenderField.propTypes = {
  entity: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};

GenderField.defaultProps = {
  required: false
};

export default GenderField;
